import { useState, useEffect } from 'react';

export const Timer = () => {
  const [count, setCount] = useState(599);
  const [countMinutes, setCountMinutes] = useState(9);
  const [countSeconds, setCountSeconds] = useState(59);

  useEffect(() => {
    let id = setInterval(() => {
      if (count) {
        let timer = count - 1;
        let seconds = timer % 60;
        if (seconds < 10) {
          seconds = `0${seconds}`;
        }
        setCountMinutes(Math.floor(timer / 60));
        setCountSeconds(seconds);
        setCount(timer);
      }
    }, 1000);
    return () => clearInterval(id);
  }, [count]);

  return (
    <div className='scoreboard__timer'>
      {countMinutes}:{countSeconds}
    </div>
  );
};
